<template>
  <v-form ref="form">
    <v-row> </v-row>
    <v-divider class="my-5" />
    <v-row>
      <v-col class="py-0" cols="12">
        <v-text-field
          ref="name"
          v-model="userGroup.name"
          :label="$t('user-groups.name')"
          :loading="resourceLoading"
          :rules="
            resourceLoading
              ? []
              : [
                  ownRules.requiredIfGivenNameAndFamilyNameIsEmpty,
                  backEndValidation('name')
                ]
          "
        ></v-text-field>
      </v-col>
    </v-row>
    <v-divider class="my-5" />
    <v-row>
      <v-col class="py-0" cols="12">
        <v-textarea
          v-model="userGroup.notices"
          :label="$t('user-groups.notices')"
          :loading="resourceLoading"
          :rules="resourceLoading ? [] : [backEndValidation('notices')]"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <ButtonWithMenu
          :loading="loading"
          :menu-hide="button_title !== 'create'"
          :general-button="{
            icon: $props.button_icon,
            text: `buttons.${$props.button_title}`,
            eventFunction: save
          }"
          :menu-items="[
            {
              icon: $props.button_icon,
              text: `buttons.create-and-new`,
              eventFunction: saveAndNew
            },
            {
              icon: $props.button_icon,
              text: `buttons.create-and-clone`,
              eventFunction: saveAndClone
            }
          ]"
        ></ButtonWithMenu>
        <template v-if="button_title !== 'create'">
          <v-btn
            class="ml-4"
            color="primary"
            :to="{
              name: 'NewUserGroup',
              query: {
                userGroup: userGroup.id
              }
            }"
            :loading="loading"
          >
            <v-icon left>mdi-plus</v-icon>
            {{ $t(`buttons.clone`) }}
          </v-btn>
        </template>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { rules } from "./../mixins/rules";
import ButtonWithMenu from "../common/buttons/ButtonWithMenu";
export default {
  name: "FormUserGroup",
  components: {
    ButtonWithMenu
  },
  mixins: [rules],
  data: () => ({
    loading: false
  }),
  props: {
    dispatch: String,
    button_title: String,
    button_icon: String,
    userGroup: {
      default: function() {
        return {
          name: ""
        };
      }
    },
    resourceLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ownRules() {
      let vm = this;
      return {
        requiredIfNameIsEmpty: value => {
          return (
            !!vm.userGroup.name ||
            !!value ||
            this.$i18n.t("validate.required-if-name-is-empty")
          );
        }
      };
    }
  },
  methods: {
    save(callback = this.defaultCallbackForSave) {
      this.clearBackEndErrors();
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store
          .dispatch(this.$props.dispatch, {
            item: { ...this.userGroup },
            errorHandler: this.errorHandler.bind(this, () => {
              this.$refs.form.validate();
            }),
            onSuccess: item => {
              if (item !== "") {
                callback(item);
              }
            }
          })
          .finally(() => (this.loading = false));
      }
    },
    saveAndClone() {
      let callback = i => {
        let { id, ...item } = i;
        this.$store.commit("userGroupStore/set", { item });
        this.$router.push({
          name: "NewUserGroup",
          query: {
            userGroup: id
          }
        });
        this.$store.dispatch(
          "notificationStore/createSuccessNotificationForApiRequest",
          {
            text: this.$t(`message.success-create`)
          }
        );
      };
      this.save(callback);
    },
    saveAndNew() {
      let callback = () => {
        this.$route.query.userGroup &&
          this.$router.push({ name: "NewUserGroup" });
        for (let member in this.userGroup) {
          let value = null;
          this.$set(this.userGroup, member, value);
          this.$refs.form.resetValidation();
        }
      };
      this.save(callback);
    },
    defaultCallbackForSave(item) {
      this.$store.commit("userGroupStore/set", { item });
      this.$router.push({
        name: "UserGroup",
        params: {
          id: item.id
        }
      });
    }
  },
  watch: {
    "userGroup.name"() {
      if (this.ownRules.requiredIfNameIsEmpty()) {
        this.$refs.name.validate();
      }
    }
  }
};
</script>

<style scoped></style>
